import React, { useState } from 'react';
import { Button } from 'antd';
import cn from 'classnames';
import Tracker from '@base/lib/Tracker';
import { getFeatureProductTrackData } from 'base/utils/features';
import ListProduct from '@base/snippets/ListProduct';
import prodListStyles from 'app/styles/modules/prod-list.module.less';
import styles from './index.module.less';
import { ProductDetailPopup } from '@app/common/ProductDetailPopup';
import useProdRecommend from '@base/product/ProdRecommend/useProdRecommend';
import Iconfont from '@base/lib/Iconfont';
import { useTrans } from 'base/utils/i18n';

type IProps = {
    variantId: string
}

const MODULE_ID = 'WEB Product Also Like';

const ProdYouMayAlsoLike: React.FC<IProps> = (props) => {
    const {
        variantId,
    } = props

    const [popupVisible, setPopupVisible] = useState<boolean>(false)
    const [popupVariantId, setPopupVariantId] = useState<string>()
    const [page, setPage] = useState<number>(1)
    const { t } = useTrans();

    const {
        variants,
        totalPage = 1,
        page: listPage = 1,
        listLoading = false
    } = useProdRecommend(variantId, page);

    return !variants.length ? null : (
        <>
            <div className={cn(styles['also-like-warp'])}>
                <div className={'wrapper'}>
                    <h2 className={styles.title}>{t('web_product_alsolike_title')}</h2>

                    <div className={styles.list}>
                        {variants.map((product, index) => {
                            return (
                                <div key={`${product.trackId}-${index}`} className={styles['item-wrap']}>

                                    <Tracker data={getFeatureProductTrackData({
                                        moduleCode: MODULE_ID,
                                        item: product,
                                        index
                                    })}>
                                        <ListProduct
                                            aTarget="_blank"
                                            product={product}
                                            imageSize={188}
                                            className={cn(prodListStyles.item, styles.item)}
                                            showTag
                                            isHoverChangeAsset
                                            onQuickView={variantId => {
                                                setPopupVariantId(variantId)
                                                setPopupVisible(true);
                                            }}
                                        />
                                    </Tracker>
                                </div>
                            )
                        })}
                    </div>

                    {listPage < totalPage && (
                        <div className={styles['pagination']}>
                            <div className={styles.more}>
                                <Button
                                    loading={listLoading}
                                    type={'text'}
                                    onClick={() => setPage(page + 1)}
                                    className={cn(styles.btn, 'pointer')}
                                >{t('web_common_view_more')} <Iconfont className={'icon-arrow-right'}/></Button>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {!!popupVariantId && (
                <ProductDetailPopup
                    variantId={popupVariantId}
                    visible={popupVisible}
                    onClose={() => setPopupVisible(false)}
                />
            )}
        </>
    );
};

export default ProdYouMayAlsoLike